import { Stack, Text, Title } from "@mantine/core";
import { useMemo } from "react";
import {
  DictionaryManagement,
  DictionaryService,
} from "../../components/feature-specific/DictionaryManagement";
import {
  ConsolidateEducationDegreesRequest,
  EducationDegree,
  EducationDegreeCreateRequest,
  EducationDegreeUpdateRequest,
} from "../../models/education.model";
import { EducationDictionaryAdminService } from "../../services/admin";

export function EducationDegreeDictionary() {
  const educationService = useMemo(
    () => new EducationDictionaryAdminService(),
    []
  );

  // Adapt EducationDictionaryAdminService to DictionaryService interface for degrees
  const dictionaryService: DictionaryService<EducationDegree> = useMemo(
    () => ({
      getDictionary: () => educationService.getEducationDegrees(),
      createItem: (item: Omit<EducationDegree, "id">) =>
        educationService.createEducationDegree({
          name: item.name,
        } as EducationDegreeCreateRequest),
      updateItem: (id: number, item: Partial<EducationDegree>) =>
        educationService.updateEducationDegree(id, {
          id,
          name: item.name!,
        } as EducationDegreeUpdateRequest),
      deleteItem: (id: number) => educationService.deleteEducationDegree(id),
      consolidateItems: (sourceId: number, targetId: number) =>
        educationService.consolidateEducationDegrees({
          sourceDegreeId: sourceId,
          targetDegreeId: targetId,
        } as ConsolidateEducationDegreesRequest),
    }),
    [educationService]
  );

  return (
    <Stack gap="md">
      <Stack gap="xs" mb="md">
        <Title order={3} size="h4" fw={600}>
          Education Degrees
        </Title>
        <Text c="dimmed">
          Manage and standardize education degrees in the system
        </Text>
      </Stack>

      <DictionaryManagement
        title="Education Degrees"
        service={dictionaryService}
        itemDisplayName="Degree"
        itemDisplayNamePlural="Degrees"
        canConsolidate={true}
        titleFieldName="name"
        searchPlaceholder="Search degrees..."
      />
    </Stack>
  );
}
